import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextRequest } from './get-collection-triage-next-request';
import type { IGetCollectionTriageNextResponse } from './get-collection-triage-next-response';
import { getCollectionTriageNextResponseSchema } from './get-collection-triage-next-response';

/**
 * @deprecated Superseded by `getCollectionTriageNextV3Api`. Frozen, not deleted -
 * an old app binary may still call it. See "Web-only / orphan versions pending
 * deletion" in apps/api/CLAUDE.md.
 */
export async function getCollectionTriageNextApi({
  collectionId,
}: IGetCollectionTriageNextRequest): Promise<IValidatedResponse<IGetCollectionTriageNextResponse>> {
  return getRequest<IGetCollectionTriageNextResponse>({
    path: `/sys/collections/${collectionId}/triage/next`,
    schema: getCollectionTriageNextResponseSchema,
  });
}
